import { Stack } from "@mui/material";
import CardDsfrContext from "components/CardDsfrContext";
import DSFRListContext from "components/DSFRListContext";
import Wrapper from "components/LayoutFront/Wrapper";
import TemplateBanner from "components/templatesComponents/TemplateBanner";
import PropTypes from "prop-types";
import React, { useMemo } from "react";

const PageLinksDsfr = (props) => {
  const { page: pageVersion = {} } = props;

  const { contents, shortDescription, title } = pageVersion;

  const { headerButtons, pageButtons, pageLinks } = contents;

  const cardDsfrContextValue = useMemo(() => ({ hasGreyBackground: true }), []);
  const dsfrListContextValue = useMemo(() => ({ xs: 12, sm: 6, lg: 4 }), []);

  const bo = useMemo(() => typeof title === "object", [title]);

  return (
    <>
      <TemplateBanner bo={bo}>
        <Stack direction={{ lg: "row" }} sx={{ alignItems: "flex-start", gap: 2 }}>
          <Stack>
            <h1>{title}</h1>
            {shortDescription && <p className="fr-text--xl">{shortDescription}</p>}
            {headerButtons && (
              <Stack direction={{ lg: "row" }} sx={{ gap: 2, mb: 2, "& a": { width: { xs: "100%", lg: "auto" } } }}>
                {headerButtons}
              </Stack>
            )}
          </Stack>
        </Stack>
      </TemplateBanner>
      <Wrapper sx={bo ? {} : { "& p": { mt: { xs: 1, lg: 4 }, mb: { xs: -5, lg: -6 } } }}>
        <DSFRListContext.Provider value={dsfrListContextValue}>
          <CardDsfrContext.Provider value={cardDsfrContextValue}>{pageLinks}</CardDsfrContext.Provider>
        </DSFRListContext.Provider>
        <Stack direction={{ lg: "row" }} sx={{ gap: 2, py: 3, "& a": { width: { xs: "100%", lg: "auto" } } }}>
          {pageButtons}
        </Stack>
      </Wrapper>
    </>
  );
};

PageLinksDsfr.propTypes = {
  page: PropTypes.shape(),
};

export default PageLinksDsfr;
